<template>
  <div :key="item.azgoId" p="6" bg="white" rounded="4" flex="~ items-stretch" mt="4" cursor-pointer @click="clickCard(item, type, 'blank_area')">
    <div class="relative">
      <van-image h="full" :src="item.coverImageUrl" fit="cover" style="vertical-align: middle;" w="42" min-h="42" flex="shrink-0" radius="0.75rem" />
      <!-- <img src="~/assets/images/rank/top_1.png" w="12" class="absolute" top="-2" left="-2" /> -->
      <BusinessBRankTag :rank="rank"></BusinessBRankTag>
      <!-- <div
        v-if="!rank && Boolean(item.subLabelNameList?.length)"
        font="300" class="absolute" top="2" left="2" bg="#00000033" rounded="1" rounded-tl="2" h="5" px="1"
        text="xs white" overflow="hidden" whitespace="nowrap" text-ellipsis pt="0.5"
        :style="{ maxWidth: 'calc(100% - 16px)' }"
      >
        {{ item.subLabelNameList?.[0] }}
      </div> -->
    </div>

    <div ml="3" flex="1 ~ col" gap="2" overflow-x="hidden" py="1">
      <div flex="1">
        <div text="lg #121212" font="500" line-clamp="2">
          {{ item.title }}
        </div>
        <div v-if="item.rating || item.tagList?.length" mt="2" flex="~ items-center">
          <template v-if="item.rating">
            <div w="6" leading="4" style="background-color: var(--tc-color-score);" rounded="1" text="xs center white" font="500">
              {{ item.rating }}
            </div>
            <span ml="1" text="#121212 xs" font="300">{{ getScoreText(Number(item.rating)) }}</span>
            <van-divider vertical style="padding: 0.15rem; margin: 0 0.25rem;" />
          </template>
          <span v-if="item.tagList?.length" text="#121212 sm" font="300">{{ item.tagList?.[0] }}</span>
        </div>
        <div v-if="item.address" flex="~ items-center" mt="2">
          <NuxtIcon mr="0.5" name="my-icon:location" text="base #808080" />
          <span text="sm #808080" font="300" line-clamp="1">{{ item.address }}</span>
        </div>
      </div>
      <div class="relative" w="full">
        <div flex="~ items-stretch nowrap" gap="4" overflow-x="auto">
          <template v-for="(supplier, index) in item.minPriceRecords?.slice(0, 3)" :key="supplier.supplierId">
            <div class="azgo-haptics-feedback" rounded="2" w="fit" cursor="pointer" @click.stop="clickSupplier(item, type, 'small_button', supplier)">
              <div flex="~ items-center">
                <img w="4" h="4" rounded="1" mr="1" :src="supplier.logoUrl" />
                <div text="xs #121212" font="300" line-clamp="1">
                  {{ supplier.supplierName }}
                </div>
              </div>
              <div text="base #121212" flex="~ items-center">
                <span mr="1">{{ getCurrencyPrice(supplier.minPrice) }}</span>
                <img src="~/assets/images/search-result/jump.png" w="4" h="4" />
              </div>
              <span v-if="supplier.cashbackDesc" text="xs" font="300" line-clamp="1" :style="{ color: 'var(--tc-color-cashback-desc)' }">{{ supplier.cashbackDesc }}</span>
            </div>
            <div v-if="index !== (item.minPriceRecords?.length ?? 0) - 1" class="van-hairline--left" my="1"></div>
          </template>
          <div v-if="(item.minPriceRecords?.length ?? 0) > 3" class="azgo-haptics-feedback" rounded="2" w="fit" cursor="pointer" @click.stop="clickCard(item, type, 'view_all')">
            <div flex="~ items-center">
              <div text="xs #121212" font="300" line-clamp="1">
                {{ t('key.search.result.button.view.all') }}
              </div>
            </div>
            <div text="base #121212" flex="~ items-center">
              <span mr="1">+{{ (item.minPriceRecords?.length ?? 3) - 3 }}</span>
              <img src="~/assets/svg/arrow-right.svg" w="3" h="3" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-divider vertical dashed style="height: auto;margin: 0 1rem;" />

    <div flex="~ col shrink-0" pt="1" min-w="42">
      <div flex="~ 1 col" items="start" gap="1">
        <div style="color: var(--el-color-primary-dark-2); background-color: var(--el-color-primary-light-9);" w="auto" class="inline-flex items-center" h="5" rounded="1" px="1">
          <NuxtIcon name="my-icon:like" text="sm" mr="0.5" style="color: var(--el-color-primary-dark-2)" />
          <span text="xs">{{ t('key.search.result.tag.best.price') }}</span>
        </div>

        <div text="6.5 #121212" font="500">
          {{ item.minPriceRecords?.[0]?.minPrice ? getCurrencyPrice(item.minPriceRecords?.[0]?.minPrice) : t('key.list.getPrice') }}
        </div>
        <img h="5" :src="item.minPriceRecords?.[0]?.jumpUrlInfoDTO?.jumpLogoUrl" />
        <span text="xs" :style="{ color: 'var(--tc-color-cashback-desc)' }">{{ item.minPriceRecords?.[0]?.cashbackDesc }}</span>
      </div>
      <div
        v-if="item.minPriceRecords?.length !== 0"
        class="azgo-haptics-feedback azgo-button-feedback"
        min-w="42"
        px="4"
        h="10"
        flex="~ items-center justify-center"
        rounded="2"
        text="sm white"
        font="500"
        @click.stop="clickSupplier(item, type, 'large_button', item.minPriceRecords![0])"
      >
        {{ t('key.list.btnTitle') }}
        <NuxtIcon name="my-icon:jump" class="ml-2" text="xs white" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SearchDTO } from '~/apis/back/types'
import type { ENUM_CARD_FROM } from '~/enums'
import { getScoreText } from '~/utils'

defineProps<{
  item: SearchDTO
  rank?: number
  type: ENUM_CARD_FROM
}>()
const { t } = useI18n()
const { clickCard, clickSupplier, getCurrencyPrice } = useSearchResult()
</script>

<style>

</style>
